import React from "react";
import { Link } from "react-router-dom";
import "./PolicyPage.css";

export default function TermsOfService() {
  return (
    <div className="policy-page">
      <header className="policy-header">
        <div className="policy-header-inner">
          <Link to="/" className="policy-brand">
            <img src="/TechXM-logo.png" alt="TECHXM logo" className="brand-logo-mark" width="30" height="30" />
          </Link>
          <nav className="policy-nav">
            <Link to="/privacy-policy">Privacy</Link>
            <Link to="/cookie-policy">Cookies</Link>
          </nav>
        </div>
      </header>

      <main className="policy-main">
        <h1 className="policy-title">Terms of Service</h1>
        <p className="policy-effective">Effective Date: March 6, 2026</p>
        <p className="policy-intro">
          These Terms of Service govern use of the TECHXM website and related
          digital services.
        </p>

        <section className="policy-section">
          <h2>Use of Website</h2>
          <p>
            You agree to use this website only for lawful purposes and in a way
            that does not disrupt service availability or website security.
          </p>
        </section>

        <section className="policy-section">
          <h2>Service Engagements</h2>
          <p>
            Project scope, commercial terms, and delivery obligations are
            defined in written proposals, statements of work, or client
            agreements.
          </p>
        </section>

        <section className="policy-section">
          <h2>Intellectual Property</h2>
          <p>
            Unless otherwise agreed in writing, all website content is owned by
            TECHXM. Client deliverables and ownership terms are governed by
            project contracts.
          </p>
        </section>

        <section className="policy-section">
          <h2>Limitation of Liability</h2>
          <p>
            To the maximum extent permitted by law, TECHXM is not liable for
            indirect or consequential losses arising from website use or
            interruptions beyond reasonable control.
          </p>
        </section>

        <section className="policy-section">
          <h2>Contact</h2>
          <p>
            Questions regarding these terms can be directed to{" "}
            <a href="mailto:admin@techxm.co.za">admin@techxm.co.za</a>.
          </p>
        </section>
      </main>
    </div>
  );
}





